export function getApiUrl (): string {
  return (
    process.env.API_URL ??
    process.env.REACT_APP_API_URL ??
    ''
  )
}
